import { Component, OnInit, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatToolbar } from "@angular/material/toolbar";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MarkdownComponent } from "ngx-markdown";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.css"],
  imports: [MatToolbar, MatTabGroup, MatTab, MarkdownComponent, TranslatePipe]
})
export class AboutComponent implements OnInit {
  private http = inject(HttpClient);

  licenseInfo: string = "Loading...";
  clientChangeLog: string = "Change log here";
  serverChangeLog: string = "Change log here";

  ngOnInit() {
    let url = "3rdpartylicenses.txt";
    this.http.get(url, { responseType: "text" }).subscribe(
      (value) => {
        this.licenseInfo = value;
      },
      (error) => {
        console.log(error);
        this.licenseInfo = "Error loading licence data";
      }
    );
  }
}
